import { useQuery } from '@tanstack/react-query';
import * as Mappers from '../mappers';
import * as Queries from '../queries';
import * as Types from '../types';

interface IProps {
  enabled?: boolean;
}

const useMyStats = ({ enabled = true }: IProps = {}) => {
  const initialData = { stats: Mappers.MyStats() } as Types.IQuery.MyStats;

  const { data = initialData, ...args } = useQuery<Types.IQuery.MyStats>({
    queryKey: ['result', 'my-stats'],
    queryFn: Queries.MyStats()[1],
    enabled,
  });

  return { ...args, ...data };
};

export default useMyStats;
